module.exports = __webpack_public_path__ + "static/main2-621c86ae16858a67c56cf305e12a5d02.jpg";